import React, { FC } from 'react';
import {render} from 'react-dom';
const rootEle = document.getElementById('root');
import { getJwtToken, clearJwtToken } from "./stores/loginUtil";
import { aFetch, setAuthtoken } from "./services/api/fetch";
import './i18n';

export async function goToLogin() {
    setAuthtoken("");
    clearJwtToken();
    let mApp: Promise<{App:FC<{}>}>;
    mApp = import("./App") as any;
    const {App} = await mApp;

    render(<App />, rootEle);
}

export async function bootstrap() {
	const jwtToken = getJwtToken();
    if (location.pathname == "/signIn" || location.pathname.indexOf("/resetPassword")!=-1) {
        goToLogin();
        return;
    }
    if (!jwtToken) {
        location.pathname = "/signIn";
        goToLogin();
        return;
    }

    setAuthtoken(jwtToken);

    // const [err, data] = await aFetch<{role:string}>("GET", `/Account/Me`);
    // if (err) {
    //     goToLogin();
    //     return;
    // }

    let mApp: Promise<{App:FC<{}>}>;
    mApp = import("./App") as any;
    const {App} = await mApp;
    render(<App />, rootEle);
}

bootstrap();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
import * as serviceWorker from './serviceWorker';
serviceWorker.unregister();
